import {
    createLinkGenerator,
    createRoute,
    mergeRoutes
} from "./routeGenerator";
import {
    LazyAssessmentListPage,
    LazyAssessmentPage
} from "@/frontend/assessment/lazyAssessmentComponents";
import {
    LazyAssessmentTypeListPage,
    LazyAssessmentTypePage,
    LazyAssessmentTypeVersionPage
} from "@/frontend/assessmentType/super/lazySuperPages";
import { LazyEvaluationResultsPage } from "@/frontend/evaluation/lazyComponents";
import { LazyFirmSettingsPage } from "@/frontend/firm/LazyFirmSettingsPage";
import {
    LazyFirmListPage,
    LazyFirmPage
} from "@/frontend/firm/super/lazySuperPages";
import { LazyPrepopulationResultsPage } from "@/frontend/prepopulation/lazyComponents";
import { LazyQuestionPage } from "@/frontend/question/lazyComponents";
import { LazyResultsPage } from "@/frontend/results/lazyComponents";
import { LazyReviewPage } from "@/frontend/review/lazyComponents";
import { LazyUserProfilePage } from "@/frontend/user/lazyUserPages";
import { LazyUserListPage } from "@/frontend/user/super/lazySuperPages";
import {
    LazyUTBTypeFirmQuestionsPage,
    LazyUTBTypeListPage,
    LazyUTBTypePage
} from "@/frontend/utbType/super/lazySuperPages";

export const routes = mergeRoutes([
    createRoute({
        path: "/profile",
        render: () => <LazyUserProfilePage />,
        allowAnyone: true
    }),
    createRoute({
        path: "/firm/settings",
        render: () => <LazyFirmSettingsPage />,
        allowAnyone: true
    }),
    createRoute({
        path: "/",
        render: () => <LazyAssessmentListPage />,
        allowAnyone: true
    }),
    createRoute({
        path: "/assessments/:assessmentId",
        render: ({ assessmentId }) => (
            <LazyAssessmentPage assessmentId={assessmentId} />
        ),
        allowAnyone: true
    }),
    createRoute({
        path: "/assessments/:assessmentId/teams/:teamId/questions/:questionKey",
        render: ({ assessmentId, teamId, questionKey }) => (
            <LazyQuestionPage
                assessmentId={assessmentId}
                teamId={teamId}
                questionKey={questionKey}
            />
        ),
        allowAnyone: true
    }),
    createRoute({
        path: "/assessments/:assessmentId/teams/:teamId/results",
        render: ({ assessmentId, teamId }) => (
            <LazyResultsPage assessmentId={assessmentId} teamId={teamId} />
        ),
        allowAnyone: true
    }),
    createRoute({
        path: "/assessments/:assessmentId/prepopulation/:requestId/results",
        render: ({ assessmentId, requestId }) => (
            <LazyPrepopulationResultsPage
                assessmentId={assessmentId}
                requestId={requestId}
            />
        )
    }),
    createRoute({
        path: "/assessments/:assessmentId/evaluations/:requestId/results",
        render: ({ assessmentId, requestId }) => (
            <LazyEvaluationResultsPage
                assessmentId={assessmentId}
                requestId={requestId}
            />
        )
    }),
    createRoute({
        path: "/assessments/:assessmentId/teams/:teamId/review",
        render: ({ assessmentId, teamId }) => (
            <LazyReviewPage assessmentId={assessmentId} teamId={teamId} />
        )
    }),
    createRoute({
        path: "/super/users",
        render: () => <LazyUserListPage />
    }),
    createRoute({
        path: "/super/firms",
        render: () => <LazyFirmListPage />
    }),
    createRoute({
        path: "/super/firms/:firmId",
        render: ({ firmId }) => <LazyFirmPage firmId={firmId} />
    }),
    createRoute({
        path: "/super/assessment-types",
        render: () => <LazyAssessmentTypeListPage />
    }),
    createRoute({
        path: "/super/assessment-types/:assessmentTypeId",
        render: ({ assessmentTypeId }) => (
            <LazyAssessmentTypePage assessmentTypeId={assessmentTypeId} />
        )
    }),
    createRoute({
        path: "/super/assessment-types/:assessmentTypeId/versions/:versionId",
        render: ({ assessmentTypeId, versionId }) => (
            <LazyAssessmentTypeVersionPage
                assessmentTypeId={assessmentTypeId}
                versionId={versionId}
            />
        )
    }),
    createRoute({
        path: "/super/utb-types",
        render: () => <LazyUTBTypeListPage />
    }),
    createRoute({
        path: "/super/utb-types/:utbTypeId",
        render: ({ utbTypeId }) => <LazyUTBTypePage utbTypeId={utbTypeId} />
    }),
    createRoute({
        path: "/super/utb-types/:utbTypeId/firm-questions",
        render: ({ utbTypeId }) => (
            <LazyUTBTypeFirmQuestionsPage utbTypeId={utbTypeId} />
        )
    })
]);

export const generateLink = createLinkGenerator(routes);
